import React from "react";
import styles from "./Header.module.less";
import Media from "react-media";

export interface Props {}

function Header(props: Props) {
    return (
        <header className={styles.Header}>
            <Media
                query={{ minWidth: 767 }}
                render={() => (
                    <video className={styles["Header-video"]} playsInline autoPlay muted loop>
                        <source src={process.env.PUBLIC_URL + "/assets/Stockholm_LoRes.mp4"} type="video/mp4" />
                    </video>
                )}
            />

            <img
                className={styles["Header-logo"]}
                src={process.env.PUBLIC_URL + "/assets/Business_Sweden_logo_white.svg"}
                alt="Logo Business Sweden"
            />

            <Media
                query={{ minWidth: 600 }}
                render={() => (
                    <>
                        <h1 className={styles["Header-heading"]}>Code of Conduct</h1>
                        <div className={styles["Header-content"]}>
                            <p>
                                A guide on how we act in our daily work, both as business partners, employers, employees
                                and members of society.
                            </p>
                        </div>
                    </>
                )}
            />
        </header>
    );
}

export default Header;
